// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1zViy","tab":"Tabs_tab__FK1KI","tabActive":"Tabs_tabActive__426Xh"};